import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';

const valueOrDash = (value) => (value === null || value === undefined || value === '' ? '-' : value);

export const exportProductMasterExcel = (products = [], categoryLabel = 'Semua Kategori') => {
    const rows = [];
    let no = 1;

    products.forEach((product) => {
        const variants = product.variant_products && product.variant_products.length > 0
            ? product.variant_products
            : [null];

        const satuan = product.product_satuan && product.product_satuan.length > 0
            ? product.product_satuan[0]
            : null;

        variants.forEach((variant) => {
            rows.push({
                No: no++,
                'Kode Barang': valueOrDash(product.product_code),
                'Nama Barang': valueOrDash(product.product_name),
                Kategori: valueOrDash(product.category?.category_name),
                Satuan: valueOrDash(satuan?.satuan),
                'Rasio Satuan': valueOrDash(satuan?.rasio_satuan),
                'Nama Variant': valueOrDash(variant?.variant_name),
                SKU: valueOrDash(variant?.SKU),
                Barcode: valueOrDash(variant?.barcode_code),
                Harga: variant?.price ?? 0,
                Stok: variant?.stock ?? 0,
                Status: product.isActive ? 'Aktif' : 'Tidak Aktif',
                Deskripsi: valueOrDash(product.description),
            });
        });
    });

    const headers = [
        'No', 'Kode Barang', 'Nama Barang', 'Kategori', 'Satuan', 'Rasio Satuan',
        'Nama Variant', 'SKU', 'Barcode', 'Harga', 'Stok', 'Status', 'Deskripsi'
    ];

    const worksheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(worksheet, [
        ['MASTER DATA PRODUK'],
        [`Kategori: ${categoryLabel}`],
        [],
        headers,
    ], { origin: 'A1' });

    XLSX.utils.sheet_add_json(worksheet, rows, {
        origin: 'A5',
        skipHeader: true,
        header: headers,
    });

    worksheet['!merges'] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } },
        { s: { r: 1, c: 0 }, e: { r: 1, c: headers.length - 1 } },
    ];

    if (worksheet.A1) {
        worksheet.A1.s = {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: 'center', vertical: 'center' },
        };
    }
    if (worksheet.A2) {
        worksheet.A2.s = {
            font: { italic: true },
            alignment: { horizontal: 'center', vertical: 'center' },
        };
    }

    const border = {
        top: { style: 'thin', color: { rgb: 'D9D9D9' } },
        bottom: { style: 'thin', color: { rgb: 'D9D9D9' } },
        left: { style: 'thin', color: { rgb: 'D9D9D9' } },
        right: { style: 'thin', color: { rgb: 'D9D9D9' } },
    };

    headers.forEach((_, index) => {
        const cell = XLSX.utils.encode_cell({ r: 3, c: index });
        if (!worksheet[cell]) return;
        worksheet[cell].s = {
            font: { bold: true },
            fill: { patternType: 'solid', fgColor: { rgb: 'FCE7F1' } },
            alignment: { horizontal: 'center', vertical: 'center' },
            border,
        };
    });

    const range = XLSX.utils.decode_range(worksheet['!ref']);
    for (let row = 4; row <= range.e.r; row++) {
        for (let col = 0; col <= range.e.c; col++) {
            const cell = XLSX.utils.encode_cell({ r: row, c: col });
            if (!worksheet[cell]) continue;
            worksheet[cell].s = {
                border,
                alignment: { vertical: 'center', wrapText: true },
            };
        }
    }

    worksheet['!cols'] = [
        { wch: 7 }, { wch: 18 }, { wch: 34 }, { wch: 24 }, { wch: 14 },
        { wch: 14 }, { wch: 28 }, { wch: 28 }, { wch: 22 }, { wch: 16 },
        { wch: 12 }, { wch: 14 }, { wch: 40 },
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Produk');

    const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const safeCategory = categoryLabel.replace(/[^a-z0-9]+/gi, '_').replace(/^_|_$/g, '');
    const fileName = safeCategory && safeCategory !== 'Semua_Kategori'
        ? `Master_Produk_${safeCategory}.xlsx`
        : 'Master_Produk_Semua_Kategori.xlsx';

    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
};
